exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shape[data-v-025cb8a1]{fill:#1edfc5}", ""]);

// exports
